// extracted by mini-css-extract-plugin
export default {"input":"PlanningView_input__UeeZ7","ellipsisText":"PlanningView_ellipsisText__XUVdZ"};